<template>
  <div class="card">
    
    <div class="grid grid-cols-6">

      <div class="col-span-6 sm:col-span-2">
        <label for="name">Nombre</label>
        <InputText v-model="name" id="name" type="text" aria-describedby="name-help" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="email">E-mail</label>
        <InputText v-model="email" id="email" type="email" aria-describedby="email-help" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="celular">Celular</label>
        <InputText v-model="phone" id="celular" type="phone" aria-describedby="celular-help" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="userID">Usuario ID</label>
        <InputText v-model="userID" id="userID" type="text" aria-describedby="userID-help" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="password">Password</label>
        <InputText v-model="password" id="password" type="text" aria-describedby="password-help" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="sucursal">Sucursal</label>
        <Dropdown inputId="sucursal" v-model="selectedSucursal" :options="cities" optionLabel="name" optionValue="code" placeholder="Sucursal" :showClear="true" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <label for="rol">Rol</label>
        <MultiSelect v-model="selectedRoles" :options="roles" optionLabel="name" placeholder="Select Cities" display="chip" />
      </div>

      <div class="col-span-6 sm:col-span-2">
        <Button label="Grabar" icon="pi pi-save" />
      </div>

    </div>

  </div>
</template>
<script>
  import { ref } from 'vue';
  import InputText from 'primevue/inputtext';
  import Dropdown from 'primevue/dropdown';
  import MultiSelect from 'primevue/multiselect';
  import Button from 'primevue/button';

  export default {
    components: {
      InputText, Dropdown, MultiSelect, Button
    },
    setup() {
      const name = ref();
      const email = ref();
      const phone = ref();
      const userID = ref();
      const password = ref();
      const selectedSucursal = ref();
      const selectedRoles = ref();
      const roles = ref([
        { name: 'Admin', code: 'admin' },
        { name: 'IS Admin', code: 'iosepsalud_admin' },
        { name: 'IS Caja', code: 'iosepsalud_caja' },
        { name: 'IS Comprobantes', code: 'iosepsalud_comprobantes' },
        { name: 'IS Configurar', code: 'iosepsalud_configurar' }
      ]);

      return {
        name, email, phone, userID, password, selectedSucursal, selectedRoles, roles,
      }
    }
  }
</script>